// Dependencies
import { route, subGroup, professionalMeta } from '@/helpers/routes'

import Profile from '@/app/settings/profile/me'
const routes = [
  route('me', '/me', Profile, professionalMeta('Meu Cadastro'))
]

export default subGroup('/profile', routes)



// WEBPACK FOOTER //
// ./src/app/professional/profile/routes.js